import React from 'react';
import ReactDOM from 'react-dom/client';
import CarnetForm from './CarnetForm';
import './CarnetForm.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<CarnetForm />);
